import PublicationNotice from "../newVodDetail/PublicationNotice";
import { isComingSoon } from "../../utils/publication";
import React, { useEffect, useState } from "react";
import SinglePlayIcon from "../../assets/icons/svg/SinglePlayIcon";
import { prettyTimeFormatter } from "../../utils/prettyTimeFormatter";
import defaultDetailPoster from "../../assets/images/default-vod-horizontal-poster.png";
import mainLoadingGif from "../../assets/loading.gif";
import localizationStrings from "../../statics/localization";
import { getPosterUrlByType } from "../../utils/findPoster";

const NewEpisodeItem = ({ episode, onSelectEpisode, loading, accessActions }) => {
  const [poster, setPoster] = useState(null);
  const [progress, setProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);

  const calcBookmarkProgress = () => {
    if (!episode.duration) return;
    if (!episode.lastDuration) return;
    
    const baseProgress = (episode.lastDuration / episode.duration) * 100;
    const isCompleted = episode.lastDuration >= (episode.duration * 0.95) || 
                       (episode.duration - episode.lastDuration) <= 30;
    
    // Show 100% progress if episode is completed, otherwise show actual progress
    const progress = isCompleted ? 100 : Math.min(baseProgress, 100);
    
    if (progress > 0 && progress <= 100) {
      setProgress(Math.max(0, progress));
      setShowProgressBar(true);
    }
  };

  const calcRemainingTime = () => {
    const remainingTime = episode.duration - episode.lastDuration;
    return prettyTimeFormatter(remainingTime);
  };

  const calcDuration = () => {
    if (episode?.duration) {
      return prettyTimeFormatter(episode?.duration);
    }
  };

  useEffect(() => {
    if (episode) {
      const horizontalPosterUrl = getPosterUrlByType(episode?.posters, "Web Landscape");
      
      setPoster(horizontalPosterUrl);
      if (episode?.lastDuration && episode?.lastDuration !== 0) {
        calcBookmarkProgress();
      } else {
        // Reset progress state if no duration
        setProgress(0);
        setShowProgressBar(false);
      }
    }
  }, [episode]);

  if (isComingSoon(episode)) accessActions = <PublicationNotice item={episode} compact />;
  const Poster = accessActions ? "div" : "button";
  const posterAction = accessActions ? {} : {
    type: "button",
    disabled: loading,
    "aria-label": `${localizationStrings.play}: ${episode?.title}`,
    onClick: () => {
      if (!loading) onSelectEpisode(episode);
    }
  };

  return (
    <div className="new-episode-item">
      <Poster {...posterAction}
        className={`episode-poster-wrapper${accessActions ? " episode-poster-unavailable" : ""}`}
      >
        <img
          className="episode-poster"
          alt=""
          src={poster}
          onError={() => {
            setPoster(defaultDetailPoster);
          }}
        />
        {!accessActions && <div className="poster-overlay">
          <div className="overlay-play-button">
            {loading ? (
              <div className="loading-gif">
                <img src={mainLoadingGif} />
              </div>
            ) : (
              <SinglePlayIcon />
            )}
          </div>
          {showProgressBar ? (
            <>
              <div className="overlay-remaining-time">
                {calcRemainingTime() + ` ${localizationStrings.left ?? "left"}`}
              </div>
              <div className="overlay-episode-progress">
                <div className="progress-all">
                  <div
                    className="progress"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
              </div>
            </>
          ) : null}
        </div>}
      </Poster>
      <div className="episode-info-wrapper">
        <div className="episode-title">{episode?.title}</div>
        <div className="episode-no-duration">
          <div className="episode-no">
            {localizationStrings.episode} {episode?.episodeNo}
          </div>
          <span>•</span>
          <div className="episode-duration">{calcDuration()}</div>
        </div>
        <span className="info-line"></span>
        <div className="episode-summary"> {episode?.summary} </div>
        {accessActions}
      </div>
    </div>
  );
};

export default NewEpisodeItem;
